import { queryOptions } from '@tanstack/react-query';

import { backendApis } from '@/backendApis';

// Asks about the hidden chat, not routine state, so it stays a desktop query.
export const reportCostQuery = (chatId: string) =>
  queryOptions({
    queryKey: ['report-cost', chatId],
    staleTime: 1000 * 60 * 5,
    retry: 1,
    queryFn: ({ signal }) => backendApis.chat.getCost(chatId, signal),
  });
